import React from 'react';

class QuesStub extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick = (qid, ans) => {
    this.props.onClick(qid, ans);
  }

  render() {
    const { queText, queId } = this.props;
    return (
      <span>
        <div className="owned-property col s12">
          <div className="row">
            <div className="col s8">
              <h6>{queText}</h6>
            </div>
            <div className="col s4">
              <button className="btn-white col s5" onClick={() => this.onClick(queId, 1)}>Yes</button>
              <button className="btn-white col s5 offset-s2" onClick={() => this.onClick(queId, 0)}>No</button>
            </div>
          </div>
        </div>
      </span>
    );
  }
}

export default QuesStub;
